import React, { useState, useEffect } from "react"
import { Switch, Tabs, Spin, Alert, Button, Checkbox, message } from 'antd'
import AccountNoData from "./CreditReportSetup/AccountNoData"
import CreditAccountList from "./CreditReportSetup/CreditAccountList"
import CreditAccountModal from "./CreditReportSetup/CreditAccountModal"
import {
    PAYER_BORROWER,
    PAYER_LOAN_OFFICER,
    hasTriMergePricing,
    normalizeBorrowerPaidPolicy,
} from "./CreditReportSetup/creditPricingUtils"
import { track } from 'statsig'
import { STATSIG, PAGE } from 'statsig/events'
import './CreditReportSettings.css'
import '../setting/creditReport/index.css'


const vendorsList = {
    'KCBCredit': 'KCB Credit',
    'AdvantageCredit': 'Advantage Credit',
    'CreditTechnology': 'Credit Technology',
    'CreditTechnologies': 'Credit Technologies',
    'PremiumCreditBureau': 'Premium Credit Bureau',
    'PremiumCreditDataCDC': 'Premium Credit Data (CDC)',
    'Xactus': 'Xactus',
}


const Feature = () => {

    const [isAccounTModalOpen, setAccounTModalOpen] = useState(false)
    const [Accounts, setAccounts] = useState([])
    const [activeTab, setActiveTab] = useState(() => {
        const saved = sessionStorage.getItem('creditReportTeamTab')
        if (saved === 'HardPull' || saved === 'SoftPull') {
            sessionStorage.removeItem('creditReportTeamTab')
            return saved
        }
        return 'SoftPull'
    })
    const [showAlert, setShowAlert] = useState(false)
    const [softCreditStatus, setSoftCreditStatus] = useState(false)
    const [loading, setLoading] = useState(false)
    const [switchLoading, setSwitchLoading] = useState(false)
    const [policyLoading, setPolicyLoading] = useState(false)
    const [connectStatus, setConnectStatus] = useState('success')
    const [handleType, setHandleType] = useState('add')
    const [borrowerPaidEnabled, setBorrowerPaidEnabled] = useState(false)
    const [defaultPayer, setDefaultPayer] = useState(PAYER_LOAN_OFFICER)
    const [allowLoOverride, setAllowLoOverride] = useState(false)

    const [initialValues, setInitialValues] = useState({
        Vendor: undefined,
        Username: "",
        Password: "",
        UseEquifax: true,
        UseExperian: true,
        UseTransUnion: true,
        AutomatedSoftCreditPull: false,
        Type: 'SoftPull'
    })
    const tabsItems = [
        {
            key: 'SoftPull',
            label: 'Soft credit check',
        },
        {
            key: 'HardPull',
            label: 'Hard credit check',
        }
    ]
    const accountData = Accounts.filter(item => item.Type === activeTab)
    const hardAccount = Accounts.find(item => item.Type === 'HardPull')
        
    const tabsOnChange = (key) => {
        setActiveTab(key)
        const tab = key === 'HardPull' ? 'hard_pull' : 'soft_pull'
        track(STATSIG.TEAM_CREDIT_REPORT.TAB, tab, { tab })
    }

    const connectAccount = () => {
        setHandleType('add')
        setInitialValues({
            Vendor: undefined,
            Username: "",
            Password: "",
            UseEquifax: true,
            UseExperian: true,
            UseTransUnion: true,
            AutomatedSoftCreditPull: false,
            Type: activeTab,
            IndividualTriMergePrice: undefined,
            JointTriMergePrice: undefined,
        })
        setAccounTModalOpen(true)
    }

    const handleAccount = async (item, type) => {
        if (type === 'edit') {
            setHandleType('edit')
            setAccounTModalOpen(true)
            setInitialValues(item)
        } else if (type === 'remove') {
            try {
                let token = sessionStorage.getItem("ZeitroA")
                setLoading(true)
                await fetch('/los/deletecreditaccount', {
                    method: 'POST',
                    body: JSON.stringify({
                        Type: item.Type
                    }),
                    headers: {
                        Authorization: "Bearer " + token,
                        Cache: "no-cache"
                    }
                })
                await getcreditaccountconfig()
                setLoading(false)
                const pullType = item.Type === 'HardPull' ? 'hard_pull' : 'soft_pull'
                track(STATSIG.TEAM_CREDIT_REPORT.REMOVE, pullType, { type: pullType })
            } catch (error) {
                setLoading(false)
            }
        }
    }

    const showConnectAlert = () => {
        setShowAlert(true)
        setTimeout(() => {
            setShowAlert(false)
        }, 5000)
    }
    const onFinish = async (value) => {
        try {
            const data = {
                ...value,
                UseEquifax: true,
                UseExperian: true,
                UseTransUnion: true,
                AutomatedSoftCreditPull: false,
                Type: activeTab
            }
            const { isAdminConfig, ...newAccount } = data
            let token = sessionStorage.getItem("ZeitroA")
            setLoading(true)
            const response = await fetch('/los/addcreditaccount', {
                method: 'POST',
                body: JSON.stringify(newAccount),
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache"
                }
            })
            if (!response.ok) {
                const errText = await response.text()
                throw new Error(errText || 'Save failed')
            }
            await getcreditaccountconfig()
            setLoading(false)
            setConnectStatus('success')
            showConnectAlert()
            const type = activeTab === 'HardPull' ? 'hard_pull' : 'soft_pull'
            if (initialValues.Vendor) {
                track(STATSIG.TEAM_CREDIT_REPORT.UPDATE, type, { type })
            } else {
                track(STATSIG.TEAM_CREDIT_REPORT.CONNECT_NEW_ACCOUNT, type, { type })
            }
        } catch (error) {
            setLoading(false)
            setConnectStatus('fail')
            showConnectAlert()
            message.error(error.message || 'Unable to save the credit account.')
        }
    }

    const handleChangeSoftcredit = async (e) => {
        try {
            const softPullAccount = Accounts.find(account => account.Type === 'SoftPull')
            let token = sessionStorage.getItem("ZeitroA")
            setSwitchLoading(true)
            await fetch('/los/addcreditaccount', {
                method: 'POST',
                body: JSON.stringify({
                    ...softPullAccount,
                    AutomatedSoftCreditPull: e
                }),
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache"
                }
            })
            await getcreditaccountconfig()
            setSwitchLoading(false)
            const enabled = e ? 'true' : 'false'
            track(STATSIG.TEAM_CREDIT_REPORT.ALLOW_SOFT_PULL_SWITCH, enabled, { enabled })
        } catch (error) {
            setSwitchLoading(false)
        }
    }

    const handleBorrowerPaidToggle = (checked) => {
        if (checked && !hasTriMergePricing(hardAccount)) {
            message.warning('Set individual and joint tri-merge prices on the team hard credit account before enabling borrower-paid.')
            return
        }
        setBorrowerPaidEnabled(checked)
        if (checked && !defaultPayer) {
            setDefaultPayer(PAYER_BORROWER)
        }
    }

    const saveBorrowerPaidPolicy = async () => {
        if (borrowerPaidEnabled && !hasTriMergePricing(hardAccount)) {
            message.error('Set individual and joint tri-merge prices before enabling borrower-paid.')
            return
        }
        try {
            setPolicyLoading(true)
            const token = sessionStorage.getItem("ZeitroA")
            const response = await fetch('/los/setborrowerpaidpolicy', {
                method: 'POST',
                body: JSON.stringify({
                    Enabled: borrowerPaidEnabled,
                    DefaultPayer: defaultPayer || PAYER_LOAN_OFFICER,
                    AllowLoOverride: allowLoOverride,
                }),
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache",
                    "Content-Type": "application/json",
                }
            })
            if (!response.ok) {
                const errText = await response.text()
                throw new Error(errText || 'Save failed')
            }
            await getcreditaccountconfig()
            message.success('Borrower-paid policy saved.')
        } catch (error) {
            message.error(error.message || 'Unable to save borrower-paid policy.')
        } finally {
            setPolicyLoading(false)
        }
    }

    const creditAccountCancel = () => {
        setInitialValues({
            Vendor: undefined,
            Username: "",
            Password: "",
            UseEquifax: true,
            UseExperian: true,
            UseTransUnion: true,
            AutomatedSoftCreditPull: false,
            Type: activeTab
        })
        setAccounTModalOpen(false)
    }
    const getcreditaccountconfig = async () => {

        let token = sessionStorage.getItem("ZeitroA")
        const response = await fetch('/los/getcreditaccountconfig', {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        })
        if (response.status !== 200) {
            console.log('Looks like there was a problem. Status Code: ' +
                response.status)

            return
        }
        const js = await response.json()
        const adminCreditAccounts = (js.Accounts || []).map(account => ({
            ...account,
            isAdminConfig: true
        }))
        setAccounts(adminCreditAccounts)
        const automatedCreditPull = (js.Accounts || []).find(account => account.Type === 'SoftPull')?.AutomatedSoftCreditPull
        setSoftCreditStatus(automatedCreditPull)
        const policy = normalizeBorrowerPaidPolicy(js.BorrowerPaidPolicy)
        setBorrowerPaidEnabled(policy.Enabled)
        setDefaultPayer(policy.DefaultPayer)
        setAllowLoOverride(policy.AllowLoOverride)
    }
    useEffect(() => {
        track(STATSIG.COMMON.VIEW, PAGE.TEAM_CREDIT_REPORT, { page: PAGE.TEAM_CREDIT_REPORT })
        getcreditaccountconfig()
    }, [])

    return (
        <div>

                <div className="creditReport-setup-title">
                    Credit report setup for team
                </div>
                <Tabs className="creditReport-setup-tabs" activeKey={activeTab} items={tabsItems} onChange={tabsOnChange} />
                <Spin spinning={loading}>
                    <div className="creditReport-setup-content">
                        {
                            activeTab === 'SoftPull' && accountData.length > 0 && (
                                <Spin spinning={switchLoading}>
                                    <div className="soft-credit-pull">
                                        <div className="credit-pull-switch">
                                            <div className="credit-pull-title">Allow borrower to initiate soft credit pull</div>
                                            <Switch checked={softCreditStatus} onChange={handleChangeSoftcredit}></Switch>
                                        </div>
                                        <div className="credit-pull-description">
                                            When enabled, borrowers automatically undergo soft credit checks as part of their application.
                                        </div>
                                    </div>
                                </Spin>
                            )
                        }
                        {
                            activeTab === 'HardPull' && (
                                <Spin spinning={policyLoading}>
                                    <div className="borrower-paid-policy">
                                        <div className="credit-pull-switch">
                                            <div className="credit-pull-title">
                                                Let borrower pay for the credit report
                                                <span className="new-badge">NEW</span>
                                            </div>
                                            <Switch checked={borrowerPaidEnabled} onChange={handleBorrowerPaidToggle} />
                                        </div>
                                        <div className="credit-pull-description">
                                            When enabled, loan officers can send the borrower a payment link instead of paying themselves. The report is pulled after the borrower pays.
                                        </div>
                                        {borrowerPaidEnabled && (
                                            <div className="borrower-paid-defaults">
                                                <div className="borrower-paid-defaults-title">Who pays by default</div>
                                                <div className="borrower-paid-defaults-hint">Applies to every new credit pull on your team.</div>
                                                <div className="payer-option-list">
                                                    <button
                                                        type="button"
                                                        className={`payer-option ${defaultPayer === PAYER_LOAN_OFFICER ? 'selected' : ''}`}
                                                        onClick={() => setDefaultPayer(PAYER_LOAN_OFFICER)}
                                                    >
                                                        <span className="payer-radio" />
                                                        <span>Loan officer pays</span>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={`payer-option ${defaultPayer === PAYER_BORROWER ? 'selected' : ''}`}
                                                        onClick={() => setDefaultPayer(PAYER_BORROWER)}
                                                    >
                                                        <span className="payer-radio" />
                                                        <span>Borrower pays</span>
                                                    </button>
                                                </div>
                                                <Checkbox
                                                    className="borrower-paid-override"
                                                    checked={allowLoOverride}
                                                    onChange={(e) => setAllowLoOverride(e.target.checked)}
                                                >
                                                    Let loan officers change this for their own pulls.
                                                </Checkbox>
                                                <div className="borrower-paid-actions">
                                                    <Button type="primary" className="borrower-paid-save" onClick={saveBorrowerPaidPolicy}>
                                                        Save
                                                    </Button>
                                                </div>
                                            </div>
                                        )}
                                        {!borrowerPaidEnabled && (
                                            <div className="borrower-paid-actions">
                                                <Button type="primary" className="borrower-paid-save" onClick={saveBorrowerPaidPolicy}>
                                                    Save
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                </Spin>
                            )
                        }
                        <div className="credit-accounts">
                            <div className="credit-accounts-title">Connected credit accounts</div>
                            {
                                showAlert && connectStatus === 'fail' && (
                                    <Alert className="connect-alert connect-fail" message="Unable to connect the credit account. Please try again." type="error" showIcon icon={<img src='/images/user-connect-fail.svg' />} />
                                )
                            }
                            {
                                showAlert && connectStatus === 'success' && (
                                    <Alert className="connect-alert connect-success" message="Credit account has been successfully connected." type="success" showIcon icon={<img src='/images/user-connect-success.svg' />}/>
                                )
                            }
                            {
                                accountData.length === 0 ? (
                                    <AccountNoData mode="team" connectAccount={connectAccount}></AccountNoData>
                                ) : (
                                    <CreditAccountList
                                        mode="team"
                                        accountList={accountData}
                                        handleAccount={handleAccount}
                                        connectAccount={connectAccount}
                                        borrowerPaidPolicy={{ Enabled: borrowerPaidEnabled }}
                                    />
                                )
                            }
                        </div>
                    </div>
                </Spin>
                <CreditAccountModal 
                    open={isAccounTModalOpen}
                    mode="team"
                    handleType={handleType}
                    activeTab={activeTab}
                    initialValues={initialValues} 
                    onFinish={onFinish}
                    onCancel={creditAccountCancel}
                >

                </CreditAccountModal>
            </div>
    )

}
export default Feature
